<template lang="pug">
  v-layout.my-6
    v-row.fill-height.ma-0(align='center' justify='center')
      v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
</template>

<script>
export default {
  name: 'ShippingTracking',
  mounted () {
    this.getTrackingLink()
  },
  methods: {
    getTrackingLink () {
      const pid = window.location.pathname.split('/')[2]
      this.$axios.get(`/shipping/yezzashipping/${pid}/tracking/`)
        .then(resp => {
          window.location.href = resp.data
        })
        .catch(() => {
          window.location.href = 'https://zoo.yezza.io/'
        })
    }
  },
}
</script>

<style scoped></style>
